export const RAPORMIDS_GET = 'RAPORMIDS_GET';
export const RAPORMIDDETAIL_GET = 'RAPORMIDDETAIL_GET';